import { UserStatusRefillStyled } from "./styled/UserStatusRefillStyled";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";

function UserStatusRefill() {
    const { getLangPath } = useLangContext();

    return <UserStatusRefillStyled className={'inactive'}>
        <h5>{getLangPath('user_statuses.refill.title')}</h5>
        <div className={'text-secondary font-size-14'}>{getLangPath('user_statuses.refill.subtitle')}</div>
    </UserStatusRefillStyled>
}

export default UserStatusRefill;
